import React from 'react';
import { Field } from 'redux-form';

const renderInputField = ({ input, label, type, readOnly, disabled, placeholder, maxLength }) => (
  <>
    <label>{label}</label>
    <input
      type="text"
      className="form-control"
      {...{ readOnly, disabled, type, ...input }}
      maxLength={maxLength}
      placeholder={placeholder}
    />
  </>
);

const renderSelectField = ({ input, label, type, readOnly, disabled, options }) => (
  <>
    <label>{label}</label>
    <select className="form-control" {...{ readOnly, disabled, type, ...input }}>
      {options.length > 0 &&
        options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </select>
  </>
);

const makeField = (component, type = 'text', otherProps = {}) => props => {
  const { refField, required, validate, label, name, note, noteWidth, ...rest } = { ...otherProps, ...props };
  return (
    <Field
      type={type}
      component={component}
      required={required}
      ref={refField}
      name={name}
      label={label}
      note={note}
      noteWidth={noteWidth}
      {...rest}
    />
  );
};

export const InputField = makeField(renderInputField);
export const SelectField = makeField(renderSelectField);
